module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Aurore-meisje-goudfolie-foliedruk-drukwerk-3.22ddfd6a.jpg";